import * as React from "react"
const RtukAgeIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1080 1080" {...props}>
    <circle
      cx={540}
      cy={540}
      r={401.71}
      style={{
        fill: "currentColor",
        stroke: "#1d1d1b",
        strokeMiterlimit: 10,
        strokeWidth: "70.75px",
      }}
    />
    <path d="M602.07 534.33c74.26 43.82 54.19 152.56-26.88 175.39-114.35 32.2-189.76-109.46-88.7-178.58-57.35-41.32-45.28-131.03 19.95-157.66 100.75-41.13 180.78 88.24 95.66 157.73l-.03 3.11Zm-82.72-104.08c-19.91 21.45-16.62 67.63 13.65 77.93 45.67 15.54 64.57-60.31 29.12-82.6-13.84-8.7-31.53-7.44-42.77 4.67Zm-6.41 225.33c19.3 18.93 52.27 14.87 67.36-7.08 27.59-40.12-2.69-106.09-52.68-86.92-35.81 13.73-40.29 68.88-14.68 94ZM362.39 373.88v276.05h57.77v57.77H229.71v-54.56l3.21-3.21h71.69V431.65h-77.04v-57.77h134.82zM788.23 504.41h64.2v57.78h-64.2v63.13l-3.21 3.21h-54.57v-66.34h-66.33v-57.78h66.33v-66.34h54.57l3.21 3.21v63.13z" />
  </svg>
)
export default RtukAgeIcon
